/**
 * 配置编译环境和线上环境之间的切换
 *
 * development  开发环境
 * production   生产环境
 * test         测试环境
 *
 * baseUrl:     域名地址
 * imgBaseUrl:  图片所在域名地址
 */

let baseUrl = ''
let socketIoUrl=''
let oss = 'https://cdn.huazhi.cloud'
let faceUrl = 'https://cdn.huazhi.cloud/hz_emoji/';
let appkey = ''
let useDb = false
let socketUrl='wss://112.125.24.249:8099/';

let visitorIdKey='hzVisitorId';
let historyMsgNum=30;
let expiredTime = 1000*60*60
let defaultImg = oss+'/hz_image/defaultavator_m.png'
let nimJs = oss + '/hz_common/NIM_Web_SDK_v6.8.0.js';


switch(process.env.VUE_APP_CURRENTMODE){
    case 'development':
        baseUrl = 'https://test.huazhi.cloud/';
        socketIoUrl = 'https://test.huazhi.cloud';
        appkey = '0555eab830f5c49bb8272b50711928b9';
        baseUrl = 'https://api.huazhi.cloud/';
        socketIoUrl = 'https://api.huazhi.cloud';
        appkey = '14e49b9bda0c36130fe211a98a30bf55'

        break;
    case 'production':
        baseUrl = 'https://api.huazhi.cloud/';
        socketIoUrl = 'https://api.huazhi.cloud';
        appkey = '14e49b9bda0c36130fe211a98a30bf55'
        break;
    case 'test':
        baseUrl = 'https://test.huazhi.cloud/';
        socketIoUrl = 'https://test.huazhi.cloud';
        appkey = '0555eab830f5c49bb8272b50711928b9'

    default:
        baseUrl = 'https://test.huazhi.cloud/';
        socketIoUrl = 'https://test.huazhi.cloud';
        appkey = '0555eab830f5c49bb8272b50711928b9'
        break;
}

let baseChatUrl = baseUrl+'im-web';
let baseUrl_1 = baseUrl+'system';
let baseUrl_8 = baseUrl+'biz'
export {
    baseChatUrl,
    baseUrl_1,
    faceUrl,
    useDb,
    socketUrl,
    visitorIdKey,
    historyMsgNum,
    baseUrl_8,
    socketIoUrl,
    appkey,
    defaultImg,
    expiredTime,
    nimJs,
}
